class NumTool {
   number_format(number, decimals, dec_point, thousands_sep) {
    /*
    　　 * 参数说明：
    　　 * number：要格式化的数字
    　　 * decimals：保留几位小数
    　　 * dec_point：小数点符号
    　　 * thousands_sep：千分位符号
    　　 * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '',
      toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.ceil(n * k) / k;
      };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while(re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  };
  numberFormat(value) {
    const k = 10000
    const sizes = ["元", "万元", "亿元"]
    const i = value < k ? 0 : Math.floor(Math.log10(value) / Math.log10(k))
    const val = Math.floor((value / k ** i) * 10000) / 10000 //向下取整
    return `${val.toFixed(2)}${sizes[i]}`
  }

  trimStr (date){

      date= date.replace(/(^\s*)|(\s*$)/g,"");
      return date

  };

  reckonHeight ( v,w,h){
    //v 容器当前宽度
    //w 容器宽度
    //h 容器高度
    return v * w / h
  }

}

export default new NumTool()
